'use strict'

import { adminPath, appPath, aqua6boAuthPath, layerPath, postgrestPath } from './basepath'

export default {
	site: {
		getSiteOfType: function () {
			return postgrestPath + 'rpc/getsiteoftype'
		}
	},
	webService: {
		ades: function () {
			return adminPath + 'synchroniseAdes'
		}
	},
	referencial: {
		getUnits: function () {
			return postgrestPath + 'sieau_chimical_units?select=code,name,symbol'
		},
		getRemarks: function () {
			return postgrestPath + 'sieau_remark_code?select=id,code,mnemonique'
		},
		getSupports: function () {
			return postgrestPath + 'sieau_supports?select=code,name'
		},
		getStandardCodification: function () {
			return postgrestPath + 'gns_standard_codifications?select=dtype,code,definition'
		},
		getParameters: function () {
			return postgrestPath + 'sieau_chimical_parameters?select=code,name'
		},
		getCities() {
			return postgrestPath + 'rpc/getcities'
		},
		getDepartments() {
			return postgrestPath + 'rpc/getdepartments'
		},
		getFilterTypes() {
			return postgrestPath + 'sieau_filter_type'
		},
		getSiteTypes() {
			return postgrestPath + 'gns_sites_types?select=id,parameter,definition'
		},
		getWatershed() {
			return postgrestPath + 'rpc/getsimplewatershed'
		},
		getSimpleStations() {
			return postgrestPath + 'rpc/getsimplestations'
		},
		getManagementWaters() {
			return postgrestPath + 'rpc/getmanagementwaters'
		},
		getSources() {
			return postgrestPath + 'sieau_source'
		},
		getIndicatorTypes() {
			return postgrestPath + 'sieau_indicator_type'
		},
		getIndicators() {
			return postgrestPath + 'sieau_drinking_sanitation_indicator'
		}
	},
	qualito: {
		getStation: function (id) {
			return adminPath + 'qualitometer/' + id
		},
		getPickupOperation: function () {
			return postgrestPath + 'rpc/getpickupoperation'
		},
		getAnalysis: function () {
			return postgrestPath + 'rpc/getanalysis'
		},
		getQualitometerKeyFigure: function () {
			return postgrestPath + 'rpc/getqualitometerkeyfigure'
		}
	},
	station: {
		getStation: function (id) {
			return adminPath + 'station/' + id
		},
		getNetworks: function () {
			return postgrestPath + 'rpc/getnetworks'
		},
		getSamplingSurfacePoints: function () {
			return postgrestPath + 'rpc/getsamplingsurfacepoint'
		},
		export: function () {
			return adminPath + 'station/export'
		},
		exportStation: function (id) {
			return adminPath + 'station/export?station=' + id
		}
	},
	piezo: {
		getAll: function () {
			return adminPath + 'piezometer'
		},
		getMeasure: function () {
			return this.getAll() + '/measure'
		},
		getPiezometer: function () {
			return postgrestPath + 'rpc/get'
		},
		getPiezometerMeasure: function () {
			return postgrestPath + 'rpc/getpiezometermeasure'
		},
		getPiezometerMeasureMax: function (id) {
			return adminPath + 'piezometer/' + id + '/measure?statistic=MAX'
		},
		getPiezometerMeasureMin: function (id) {
			return adminPath + 'piezometer/' + id + '/measure?statistic=MIN'
		},
		getPiezometerMeasureMoyenne: function (id) {
			return adminPath + 'piezometer/' + id + '/measure?statistic=MOYENNE'
		},
		getPiezometerKeyFigure: function () {
			return postgrestPath + 'rpc/getpiezometerkeyfigure'
		}
	},
	hydrometric: {
		getAll: function () {
			return adminPath + 'hydrologicalstation'
		},
		getMeasure: function () {
			return this.getAll() + '/height'
		}
	},
	pluvio: {
		getAll: function () {
			return adminPath + 'pluviometer'
		},
		getMeasure: function () {
			return this.getAll() + '/measure'
		}
	},
	contact: {
		post: function () {
			return adminPath + 'contact'
		}
	},
	applicationDescription: {
		getMetaInfomations: function () {
			return adminPath + 'applicationDescription/metainformations'
		}
	},
	login: {
		login: function () {
			return aqua6boAuthPath + 'aquadb/login'
		},
		getLogin: function () {
			return adminPath + 'login'
		}
	},
	user: {
		saveUser: function () {
			return adminPath + 'user'
		},
		updateFirstConnection: function () {
			return adminPath + 'user/firstConnection'
		},
		checkUserExist: function () {
			return aqua6boAuthPath + 'aquadb/userAccountActivation'
		},
		checkEmailExist: function () {
			return aqua6boAuthPath + 'aquadb/updateToken'
		},
		updatePassword: function () {
			return aqua6boAuthPath + 'aquadb/userAccountNewPassword'
		},
		getRoles: function (login) {
			return aqua6boAuthPath + 'aquadb/roles?login=' + login
		}
	},
	sites: {
		getChildWatershed() {
			return postgrestPath + 'rpc/getwatershedchild'
		},
		getByWatershed() {
			return postgrestPath + 'rpc/searchbywatershed'
		},
		getWatershed() {
			return postgrestPath + 'rpc/getwatershed'
		},
		getCityWatershed() {
			return postgrestPath + 'rpc/getcitywatershedlevel4'
		},
		getDepartmentWatershed() {
			return postgrestPath + 'rpc/getdepartmentwatershedlevel4'
		},
		getSageWatershed() {
			return postgrestPath + 'rpc/getsagewatershedlevel4'
		},
		getRadiusWatershed() {
			return postgrestPath + 'rpc/getradiuswatershedlevel4'
		},
		getSimpleStationResearch() {
			return postgrestPath + 'rpc/getsimplestation'
		},
		getSimpleStationWatershed() {
			return postgrestPath + 'rpc/getsimplepointwatershedlevel4'
		},
		addOrRemoveSites() {
			return adminPath + 'user/site'
		},
		getKeyFigures() {
			return postgrestPath + 'rpc/getkeyfigures'
		},
		getSamplingPoints(ids) {
			return postgrestPath + 'sieau_sampling_surface_point?select=code,id&id=in.' + ids
		}
	},
	city: {
		getCity(code) {
			return adminPath + 'city/?city=' + code
		},
		getCitiesWithId(ids) {
			return postgrestPath + 'gns_cities?select=id,name,postal_code,code&id=in.' + ids
		},
		getIndicators() {
			return postgrestPath + 'rpc/getcityindicators'
		},
		getInformations() {
			return postgrestPath + 'rpc/getcityinformations'
		}
	},
	industrialSite: {
		get(id) {
			return postgrestPath + 'sieau_industrial_site?id=eq.' + id
		}
	},
	pollutedSoil: {
		get(id) {
			return postgrestPath + 'sieau_polluted_soil?id=eq.' + id
		}
	},
	selection: {
		get(login) {
			return postgrestPath + 'sieau_selection?role=eq.ROLE_ADMIN_' + login
		},
		getSelection(id, login) {
			return postgrestPath + 'sieau_selection?id=eq.' + id + '&=eq.ROLE_ADMIN_' + login
		},
		getSelectionByName() {
			return postgrestPath + 'rpc/getselection'
		},
		getSelectionSites() {
			return postgrestPath + 'rpc/getselectionsites'
		},
		getSelectionFilters() {
			return postgrestPath + 'rpc/getselectionfilter'
		},
		getFilters() {
			return postgrestPath + 'rpc/getselectionfiltervalue'
		},
		getExportHistory() {
			return postgrestPath + 'rpc/getexporthistory'
		},
		getSelectionWatershed() {
			return postgrestPath + 'rpc/getselectionwatershed'
		},
		selectionsPath() {
			return adminPath + 'selections'
		},
		selectionPath(id) {
			return adminPath + 'selection/' + id
		},
		getSites() {
			return postgrestPath + 'rpc/getsimplesites'
		},
		updateExecution(id) {
			return adminPath + 'selection/' + id + '/execution'
		},
		status() {
			return postgrestPath + 'sieau_selection_status'
		},
		export(id) {
			return adminPath + 'export/selection/' + id
		},
		addFavorite(id) {
			return adminPath + 'selection/favorite/' + id
		},
		removeFavorite(id) {
			return adminPath + 'selection/removeFavorite/' + id
		}
	},
	signup: function () {
		return adminPath + 'signup'
	},
	activatePath: function () {
		return adminPath + 'activate'
	},
	signupUrl: function () {
		return appPath + 'signup'
	},
	layer: {
		cityLayer: function (code) {
			return layerPath + 'communes/' + code + '.kml'
		},
		departmentLayer: function (code) {
			return layerPath + 'departments/' + code + '.kml'
		},
		whatershedLayer: function (watershedCode) {
			return layerPath + 'masseEau/' + watershedCode + '.kml'
		},
		managementWaterLayer: function (managementWaterCode) {
			return adminPath + 'map/managementWater/' + managementWaterCode
		}
	},
	credit: {
		initCredit: function () {
			return adminPath + 'credit/init'
		},
		userCredit: function () {
			return postgrestPath + 'rpc/getusercredit'
		},
		userCreditHystory: function () {
			return postgrestPath + 'rpc/getusercredithistory'
		},
		creditType: function () {
			return postgrestPath + 'aquadb_credit_type'
		},
		creditRequest: function () {
			return adminPath + 'credit/request'
		}
	},
	dataType: {
		getDataTypeKeyFigures: function () {
			return postgrestPath + 'rpc/getkeyfiguresdatatype'
		}
	},
	point: {
		getDetailPoint: function () {
			return postgrestPath + 'rpc/getdetailpoint'
		}
	},
	distance: {
		getDistance: function (xRef, yRef, xDest, yDest) {
			return 'http://maps.googleapis.com/maps/api/distancematrix/json?origins=' + yRef + ',' + xRef + '?destinations=' + yDest + ',' + xDest
		}
	}
}



// WEBPACK FOOTER //
// ./src/conf/ApplicationConf.js